<template>
  <section class="section-login">
    <div class="container">
      <div class="row">
        <div class="col-sm-6 col-sm-offset-3">
          <div class="panel panel-default">
            <div class="panel-heading text-center">
              <h3 class="panel-title">Sign in</h3>
            </div>
            <div class="panel-body">
              <form @submit.prevent="submit">
                <div class="form-group">
                  <label>Username</label>
                  <input
                    v-model.trim="username"
                    type="text"
                    class="form-control"
                    autocomplete="username"
                    required
                  />
                </div>

                <div class="form-group">
                  <label>Password</label>
                  <input
                    v-model="password"
                    type="password"
                    class="form-control"
                    autocomplete="current-password"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Authenticator Code</label>
                  <input
                    v-model.trim="otpCode"
                    type="text"
                    class="form-control"
                    inputmode="numeric"
                    pattern="\\d*"
                    autocomplete="one-time-code"
                    placeholder="Optional unless MFA is enabled"
                  />
                </div>

                <div class="text-right">
                  <button
                    :disabled="loading"
                    type="submit"
                    class="btn btn-danger"
                    title="Login"
                  >
                    <span v-if="loading" class="glyphicon glyphicon-refresh spinning" aria-hidden="true"></span>
                    {{ loading ? 'Signing in…' : 'Login' }}
                  </button>
                </div>

                <p v-if="error" class="text-danger" style="margin-top:10px">{{ error }}</p>
              </form>
            </div>
          </div>
          <p class="text-muted text-center small">Use your admin credentials.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const router = useRouter()
const auth = useAuthStore()

const username = ref('')
const password = ref('')
const otpCode = ref('')
const loading  = ref(false)
const error    = ref('')

onMounted(() => {
  // If already logged in, bounce to the right dashboard
  if (auth.isLoggedIn) goHome()
})

function goHome() {
  if (auth.isAdminRole) router.replace('/admin')
  else if (auth.permission === 'employee') router.replace('/employee')
  else router.replace('/general')
}

async function submit() {
  error.value = ''
  loading.value = true
  try {
    await auth.login(username.value, password.value, otpCode.value || undefined)  // calls /api/login in your store
    goHome()
  } catch (e) {
    // Axios 401/422 or network
    const detail = e?.response?.data?.detail
    if (detail === 'MFA code required') {
      error.value = 'Please enter your authenticator code.'
    } else {
      error.value = detail || 'Login failed'
    }
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.section-login { padding: 100px 0; } /* fits legacy spacing */
.spinning { animation: spin 1s linear infinite; display: inline-block; }
@keyframes spin { from {transform: rotate(0deg)} to {transform: rotate(360deg)} }
</style>
